import { MAX_FILE_SIZE_MB, MaxSizeFileType } from 'shared/constants/MAX_SIZE';

export const sizeLimitValue = (type: MaxSizeFileType) => {
  const maxSizeMB = MAX_FILE_SIZE_MB[type];
  return maxSizeMB >= 1024 ? `${(maxSizeMB / 1024).toFixed(2)} GB` : `${maxSizeMB} MB`;
};
